import { Box, Input, Text, VStack } from '@chakra-ui/react';

import type { QuestionOption as QuestionOptionType } from './types';

const BRAND_NAVY = '#2c5282';

interface QuestionOptionProps {
  option: QuestionOptionType;
  isSelected: boolean;
  onClick: () => void;
  type: 'single_choice' | 'multi_choice';
  isEditable?: boolean;
  editValue?: string;
  onEditChange?: (value: string) => void;
}

export function QuestionOption({
  option,
  isSelected,
  onClick,
  type: _type,
  isEditable = false,
  editValue = '',
  onEditChange,
}: QuestionOptionProps) {
  const handleInputClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    onEditChange?.(e.target.value);
  };

  return (
    <Box
      as={isEditable && isSelected ? 'div' : 'button'}
      onClick={!isEditable || !isSelected ? onClick : undefined}
      p={2}
      borderRadius="md"
      border="1px solid"
      borderColor={isSelected ? BRAND_NAVY : 'gray.200'}
      bg={isSelected ? `${BRAND_NAVY}08` : 'white'}
      _hover={
        !isEditable || !isSelected
          ? {
              borderColor: 'gray.300',
              bg: 'gray.50',
            }
          : {}
      }
      transition="all 0.2s"
      textAlign="left"
      width="100%"
      cursor={!isEditable || !isSelected ? 'pointer' : 'default'}
    >
      <VStack align="start" spacing={0.5} width="100%">
        {isEditable && isSelected && option.id === 'other' ? (
          <Input
            placeholder="Enter your custom response..."
            value={editValue}
            onChange={handleInputChange}
            onClick={handleInputClick}
            size="sm"
            autoFocus
            border="none"
            bg="transparent"
            p={0}
            h="auto"
            minH="auto"
            _focus={{
              boxShadow: 'none',
            }}
            fontSize="xs"
            fontWeight={isSelected ? '600' : 'normal'}
            width="100%"
          />
        ) : (
          <Text fontWeight={isSelected ? '600' : 'normal'} fontSize="xs">
            {option.label}
          </Text>
        )}
        {option.description && (
          <Text fontSize="2xs" color="gray.600">
            {option.description}
          </Text>
        )}
      </VStack>
    </Box>
  );
}
